import { render, staticRenderFns } from "./BaseUploadDragger.vue?vue&type=template&id=d6638824&"
import script from "./BaseUploadDragger.vue?vue&type=script&lang=js&"
export * from "./BaseUploadDragger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports